module.exports = __webpack_public_path__ + "img/wechat-feed-2018.e4711d5c.jpg";